import React from 'react'
import cx from 'classnames'
import './style.sass'

export const Paper = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => {
	const cs = cx('Paper', className)
	return <div className={cs}>{children}</div>
}
